import { profiles, normalizeHost, isBridgeType } from './profiles.js';
import { parseSmbHost, smbHostFromInput } from './storage-bridge.js';
import { makeClient, providerType } from './clients.js';
import { net } from './net.js';
import { parseM3UAsync } from './m3u-async.js';
import { subscriptionOf } from './subscription.js';
import { storage } from './storage.js';
import { tunerSource, m3uTextFrom } from './tuner.js';

/* Conectar un proveedor: dejar los datos en su forma final y comprobar que entra. Lo comparten el formulario de
   la app y la página que se abre en el móvil (lan-setup.js), para que las dos hagan exactamente lo mismo. */

/**
 * Normaliza los datos de un proveedor y comprueba que están completos. Devuelve una copia lista para guardar;
 * lanza Error('fields') si falta algo.
 */
export function prepareProvider(input) {
    const data = Object.assign({ type: 'xtream', name: '', host: '', username: '', password: '', m3uUrl: '', epgUrl: '' }, input);
    data.name = String(data.name || '').trim();
    data.username = String(data.username || '').trim();
    data.m3uUrl = String(data.m3uUrl || '').trim();
    data.epgUrl = String(data.epgUrl || '').trim();
    data.host = data.type === 'm3u' ? '' : data.type === 'smb' ? (parseSmbHost(String(data.host || '').trim()) ? String(data.host).trim() : smbHostFromInput(data.host)) : isBridgeType(data.type) ? String(data.host || '').trim() : normalizeHost(data.host || '');
    // Si pegan una URL get.php de Xtream en el campo M3U, la convertimos en cuenta Xtream.
    if (data.type === 'm3u') {
        // La dirección de un sintonizador de la red (HDHomeRun, TVHeadend) se convierte en su lista y su guía.
        const tuner = tunerSource(data.m3uUrl);
        if (tuner) { data.m3uUrl = tuner.url; if (!data.epgUrl) data.epgUrl = tuner.epgUrl; if (!data.name) data.name = tuner.kind === 'tvheadend' ? 'TVHeadend' : 'HDHomeRun'; }
        const parsed = profiles.fromM3uUrl(data.m3uUrl);
        if (parsed) Object.assign(data, parsed, { m3uUrl: '' });
    }
    const kind = providerType(data.type);
    if (!kind) throw Object.assign(new Error('fields'), { code: 'fields' });
    // Plex entra con su token; el nombre de usuario queda fijo para que el servidor lo acepte.
    if (kind.fields === 'token') data.username = 'plex';
    const complete = kind.fields === 'none' ? true
        : kind.fields === 'm3u' ? !!data.m3uUrl
        : kind.fields === 'token' ? !!(data.host && data.password)
            : kind.fields === 'folder' ? !!data.host
                : kind.fields === 'smb' ? !!parseSmbHost(data.host)
                    : kind.fields === 'local' ? !!(data.host && data.folderUri)
                        : kind.fields === 'cloud' ? !!(data.host && data.password)
                : kind.group === 'library' ? !!(data.host && data.username)
                    : !!(data.host && data.username && data.password);
    if (!complete) throw Object.assign(new Error('fields'), { code: 'fields' });
    return data;
}

/** Comprueba que el proveedor entra (o que la lista M3U trae algo). Devuelve { sub } o lanza el error del cliente. */
export async function verifyProvider(data, { editingId } = {}) {
    const kind = providerType(data.type);
    if (kind.fields !== 'm3u') {
        const client = makeClient(Object.assign({ id: editingId || 'nuevo' }, data));
        const auth = await client.auth();
        storage.remove('ms-session:nuevo');
        return { sub: subscriptionOf({ user: auth.user_info || {} }) };
    }
    const text = m3uTextFrom(await net.fetchText(data.m3uUrl, { timeout: 60000 }), data.m3uUrl);
    const parsed = await parseM3UAsync(text);
    if (!parsed.live.length && !parsed.vod.length && !parsed.series.length) throw new Error('m3u');
    return { sub: null };
}

/** Código corto del motivo de un fallo al conectar (lo que se le cuenta al móvil). */
export function connectErrorCode(err, data) {
    const kind = providerType(data && data.type) || {};
    if (err && err.code === 'fields') return 'fields';
    if (kind.group === 'files' || kind.group === 'storage') return err && err.code === 'auth' ? 'files_auth' : err && err.code === 'empty' ? 'files_empty' : 'files';
    if (err && err.code === 'auth') return kind.fields === 'token' ? 'token' : 'auth';
    if (kind.group === 'library') return 'library';
    if (err && err.message === 'm3u') return 'm3u';
    return 'host';
}
